/**
 * @generated SignedSource<<7892fffa7bef08af7c9a2b219612774d>>
 * @relayHash 665e3c355d508bfb2bd11bc8457993b4
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 665e3c355d508bfb2bd11bc8457993b4

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "proposition"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "proposition",
        "variableName": "proposition"
      }
    ],
    "concreteType": "PropositionResponse",
    "kind": "LinkedField",
    "name": "saveProposition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "propositionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contractNumbers",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ccnVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "healthCcnVersion",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SavePropositionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SavePropositionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "665e3c355d508bfb2bd11bc8457993b4",
    "metadata": {},
    "name": "SavePropositionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "be71201895827fdae6e5106781c1e66a";

export default node;
